module.exports = require("@wildboar/x500/src/lib/modules/DirectoryAbstractService/FamilyEntries.ta");